<div class="date-picker">
  <span class="date-picker__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" focusable="false">
      <path fill="currentColor" d="M7 2v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2Zm12 8v10H5V10ZM5 8V6h14v2Z" />
    </svg>
  </span>
  <input #inputEl type="text" [placeholder]="placeholder" [disabled]="disabled" />
</div>
